<template>
  <div class="comic-notice-bar">
    <div class="notice-text-container" :style="{ animationDuration: time + 's' }">
      <div class="notice-text">{{ text }}</div>
      <div class="notice-text">{{ text }}</div>
      <div class="notice-text">{{ text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    time: {
      type: Number,
      default: 8,
    },
  },
}
</script>
<style lang="less" scoped>
.comic-notice-bar {
  font-size: 0;
  overflow: hidden;
  width: 100%;
  height: 20px;
  position: relative;
  .notice-text-container {
    display: inline-block;
    white-space: nowrap;
    animation: move 8s infinite linear;
  }
  .notice-text {
    font-family: 'HYYakuHei55W';
    font-size: 20px;
    color: #fff;
    line-height: 20px;
    display: inline-block;
    margin: 0 10px;
  }
  @keyframes move {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-33.3%);
    }
  }
}
</style>
